import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(Vuex, axios, VueAxios);

const removeFromArray = (array, value) => {
  const newArray = [...array];
  const index = newArray.indexOf(value);
  if (index > -1) {
    newArray.splice(index, 1);
    return newArray;
  }
  return array;
};

const removeTagFromArray = (array, value) => {
  const newArray = [...array];

  let index = newArray.findIndex(function (post, key) {
    if (post.term_id == value[1] && post.type_name == value[0]) return true;
  });

  if (index > -1) {
    newArray.splice(index, 1);
    return newArray;
  }

  return array;
};

export default new Vuex.Store({
  state: {
    page_type: window.lp_hub_data.page_type,
    rest_url: window.lp_hub_data.rest_url,
    taxonomies: Object.values(window.lp_hub_data.taxonomies),
    post_types_list: window.lp_hub_data.post_types_list,
    tags_list: window.lp_hub_data.tags_list,
    posts_per_page: window.lp_hub_data.posts_per_page,
    stylesheet_directory: window.lp_hub_data.stylesheet_directory,
    i18n: window.lp_hub_data.i18n,
    posts: null,
    wp_total: 0,
    wp_totalpages: 0,
    post_types: [],
    tags: [],
    filterTags: [],
    currentPage: 1,
    searchInput: "",
    isLoading: true,
    additionnalPage: false,
    post_types_for_filter: window.lp_hub_data.post_types_for_filter,
  },

  mutations: {
    UPDATE_POSTS(state, value) {
      state.posts = value;
      window.dispatchEvent(new Event("resize"));
    },

    UPDATE_HEADERS(state, value) {
      state.wp_total = value["x-wp-total"];
      state.wp_totalpages = value["x-wp-totalpages"];
    },

    UPDATE_PAGE(state, value) {
      state.currentPage = value;
    },

    UPDATE_LOADING(state, value) {
      state.isLoading = value;
    },

    UPDATE_SEARCH(state, value) {
      state.searchInput = value;
    },

    ADD_TAXONOMY(state, payload) {
      state.taxonomies[payload[0]].active.push(payload[1]);

      const termsList = state.taxonomies[payload[0]].terms;

      let name = "";

      for (const property in termsList) {
        if (termsList[property].term_id == payload[1]) {
          name = termsList[property].name;
        }
      }

      state.filterTags.push({
        type: "taxonomy",
        type_name: payload[0],
        term_id: payload[1],
        name: name,
      });
    },

    ADD_TAG(state, payload) {
      state.tags.push(payload[1]);

      state.filterTags.push({
        type: "tag",
        type_name: "tag",
        term_id: payload[1],
        name: payload[0],
      });
    },

    REMOVE_TAG(state, payload) {
      const newArray = removeFromArray(state.tags, payload);
      state.tags = newArray;

      const newFilterTags = removeTagFromArray(state.filterTags, [
        "tag",
        payload,
      ]);
      state.filterTags = newFilterTags;
    },

    REMOVE_TAXONOMY(state, payload) {
      const newArray = removeFromArray(
        state.taxonomies[payload[0]].active,
        payload[1]
      );
      state.taxonomies[payload[0]].active = newArray;

      const newFilterTags = removeTagFromArray(state.filterTags, payload);
      state.filterTags = newFilterTags;
    },
    REMOVE_ALL_TAXONOMY(state, payload) {
      state.taxonomies[payload].active = [];

      let newFilterTags = state.filterTags.filter(function (tag) {
        return tag.type_name != payload;
      });

      state.filterTags = newFilterTags;
    },

    ADD_POSTTYPE(state, payload) {
      state.post_types.push(payload[1]);

      state.filterTags.push({
        type: "post_type",
        type_name: "post_type",
        term_id: payload[1],
        name: payload[0],
      });
    },

    REMOVE_POSTTYPE(state, payload) {
      const newArray = removeFromArray(state.post_types, payload);
      state.post_types = newArray;

      const newFilterTags = removeTagFromArray(state.filterTags, [
        "post_type",
        payload,
      ]);
      state.filterTags = newFilterTags;
    },

    REMOVE_ALL_POSTTYPES(state) {
      state.post_types = [];

      let newFilterTags = state.filterTags.filter(function (tag) {
        return tag.type_name != "post_type";
      });

      state.filterTags = newFilterTags;
    },

    SET_ADDITIONNAL_PAGE(state, payload) {
      if (payload == false) {
        state.additionnalPage = false;
        return;
      }

      let postTypeHasPage = state.post_types_list.filter(function (post_type) {
        return post_type.name == payload.type;
      });

      if (postTypeHasPage.length > 0) {
        state.additionnalPage = payload;
      } else {
        state.additionnalPage = false;
      }
    },
  },

  actions: {
    addLoaders({ commit, state }, value) {
      let posts = state.posts;

      for (let i = 0; i < value; i++) {
        posts.push({
          id: i,
          type: "loader",
        });
      }

      commit("UPDATE_POSTS", posts);
    },

    refreshApi({ state, commit, dispatch }) {
      commit("UPDATE_LOADING", true);

      const url = new URL(this.state.rest_url + "wp/v2/posts");

      const params = new URLSearchParams();

      state.taxonomies.forEach(function (taxonomy) {
        if (taxonomy.active.length > 0) {
          params.set(taxonomy.taxonomy, taxonomy.active.join());
        }
      });

      if (state.post_types.length > 0) {
        params.set("type", state.post_types.join());
      } else {
        var post_types_list = state.post_types_list.map((obj) => {
          return obj.name;
        });

        params.set("type", post_types_list);
      }

      if (state.tags.length > 0) {
        params.set("tags", state.tags.join());
      }

      if (state.searchInput != "") {
        params.set("s", state.searchInput);
      }

      params.set("page", state.currentPage);

      url.search = params.toString();

      axios({
        method: "get",
        url: url.toString(),
        headers: {
          "content-type": "application/json",
        },
      }).then((response) => {
        let newPosts;

        if (state.currentPage > 1) {
          const posts = state.posts.filter((post) => post.type != "loader");

          newPosts = posts.concat(response.data);
        } else {
          newPosts = response.data;
        }

        if (state.additionnalPage && state.currentPage == 1) {
          const url = new URL(this.state.rest_url + "wp/v2/posts");

          const params = new URLSearchParams();

          params.set("type", state.additionnalPage.type);

          params.set("include", state.additionnalPage.include);

          url.search = params.toString();

          axios({
            method: "get",
            url: url.toString(),
            headers: {
              "content-type": "application/json",
            },
          }).then((secondResponse) => {
            newPosts = secondResponse.data.concat(newPosts);

            commit("UPDATE_LOADING", false);

            commit("UPDATE_POSTS", newPosts);

            const headers = {
              "x-wp-total":
                parseFloat(secondResponse.headers["x-wp-total"]) +
                parseFloat(response.headers["x-wp-total"]),
              "x-wp-totalpages": response.headers["x-wp-totalpages"],
            };

            commit("UPDATE_HEADERS", headers);
          });
        } else {
          commit("UPDATE_LOADING", false);

          commit("UPDATE_POSTS", newPosts);
          commit("UPDATE_HEADERS", response.headers);
        }
      });
    },

    discoverMore({ state, commit, dispatch }) {
      if (state.currentPage < state.wp_totalpages) {
        commit("UPDATE_PAGE", state.currentPage + 1);

        let loadersCount = state.wp_total - state.posts.length;

        dispatch("addLoaders", Math.min(loadersCount, state.posts_per_page));

        dispatch("refreshApi");
      }
    },

    newRequest({ state, commit, dispatch }) {
      commit("UPDATE_PAGE", 1);
      commit("UPDATE_POSTS", []);
      dispatch("addLoaders", state.posts_per_page);
      dispatch("refreshApi");
    },
  },

  getters: {
    getPostTypeName: (state) => (value) => {
      let post = state.post_types_list.filter(function (object) {
        return object.name == value;
      });

      if (post.length > 0) {
        return post[0].label;
      }

      return false;
    },

    getTagName: (state) => (value) => {
      let tag = state.tags_list.filter(function (object) {
        return object.term_id == value;
      });

      if (tag.length > 0) {
        return tag[0].name;
      }

      return false;
    },

    getLinkLabel: (state) => (postType) => {
      if (postType == "event" || postType == "training") {
        return state.i18n.event_link_label;
      } else {
        return state.i18n.link_label;
      }
    },

    getTagById: (state) => (id) => {
      let tag = state.tags_list.filter(function (object) {
        return object.term_id == id;
      });

      return tag[0];
    },
  },
});
